/**
 * Il riassunto in cima ai carichi, del giocatore (V69) e della squadra (V68):
 * la dose del periodo in grande, sotto il filtro per categoria, il badge
 * dell'ACWR e l'avviso delle sedute sotto target.
 */

import { TriangleAlertIcon } from 'lucide-react';
import { ETICHETTA_FAMIGLIA_ATTRIBUTO, type EsitoAcwr } from '@calcio/shared';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { IconaFamiglia } from '../comuni/famiglie.js';
import { coloreAcwr, etichettaAcwr } from './carichi.js';
import { type FiltroFamigliaAttributo, migliaia } from './serieSquadra.js';

export function RiassuntoPeriodo({
  dose,
  totale,
  famiglia,
  acwr,
  avviso,
}: {
  /** La dose sotto il filtro. */
  dose: number;
  /** La dose di tutte le categorie, per la quota della famiglia. */
  totale: number;
  famiglia: FiltroFamigliaAttributo;
  acwr: EsitoAcwr;
  /** Il testo dell'avviso sotto target; senza, niente avviso. */
  avviso?: string;
}) {
  const filtrata = famiglia !== 'tutti';
  return (
    <Card>
      <CardContent className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
          <div className="flex flex-col">
            <span className="flex items-center gap-1.5 text-xs font-medium tracking-wide text-muted-foreground uppercase">
              Dose del periodo
              {filtrata && (
                <>
                  <span aria-hidden>·</span>
                  <IconaFamiglia famiglia={famiglia} aria-hidden className="size-3.5" />
                  {ETICHETTA_FAMIGLIA_ATTRIBUTO[famiglia]}
                </>
              )}
            </span>
            <span className="text-4xl font-bold tabular-nums">
              {migliaia(dose)}
              <span className="ml-1 text-base font-medium text-muted-foreground">UA</span>
            </span>
            {filtrata && (
              <span className="text-sm text-muted-foreground tabular-nums">
                {totale === 0 ? 0 : Math.round((dose / totale) * 100)}% di {migliaia(totale)} UA
              </span>
            )}
          </div>
          <Badge className={cn('h-7 px-3 text-sm', coloreAcwr(acwr))}>
            ACWR {etichettaAcwr(acwr)}
          </Badge>
        </div>
        {avviso && (
          <Alert>
            <TriangleAlertIcon />
            <AlertTitle>Sotto il target</AlertTitle>
            <AlertDescription>{avviso}</AlertDescription>
          </Alert>
        )}
      </CardContent>
    </Card>
  );
}
